export default __webpack_public_path__ + "static/media/heroStudyimage.9cbe714f.png";